export const isLayerOpened = state => state.isLayerOpened
export const locale = state => state.locale
export const fullLocale = state => state.fullLocale
export const scrollState = state => state.scrollState
export const searchState = state => state.searchState



// WEBPACK FOOTER //
// ./src/store/getters.js